import { useTranslation } from "react-i18next";
import DefaultModal from "./default";
import Button from "components/button/default";
import { Dispatch, SetStateAction, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { checkEmlIdApi } from "components/api/user";
import {
  alertControl,
  emailRegex,
  modalControl,
  successControl,
} from "util/commAction";

type IProps = {};

export default function ResetPwdModal({}: IProps) {
  const { t } = useTranslation();

  const [emlId, setEmlId] = useState("");
  const [isAble, setIsAble] = useState(false);

  // 비밀번호 확인
  const emlCheckMutation = useMutation({
    mutationFn: checkEmlIdApi,
    onSuccess: (res) => {
      if (res) {
        successControl({
          status: res.status,
          success: () => {
            alertControl({
              isOpen: true,
              inner: t("alr_find_pwd"),
              click: () => {
                modalControl({
                  isOpen: false,
                });
              },
            });
          },
        });
      }
    },
  });
  const handleCheckPwd = () => {
    if (!emailRegex.test(emlId)) {
      return alertControl({
        isOpen: true,
        inner: t("alr_reg_mail"),
      });
    }

    emlCheckMutation.mutate({ emlId });
  };

  return (
    <div className="text-center relative py-3">
      <div className="flex">
        <h3 className="w-full text-center">{t("ttl_md_fnd_pss")}</h3>
        <button
          className="btn-close small absolute -top-7 -right-2"
          onClick={() => {
            alertControl({
              isOpen: false,
            });
          }}
        />
      </div>
      <p className="text-gray-500 text-xs pt-2 pb-3 break-keep leading-4">
        {t("dscrp_fnd_pss_md")}
      </p>
      <input
        type="text"
        name="emlId"
        onChange={(e) => {
          const value = e.currentTarget.value;
          const next = e.currentTarget.nextSibling as HTMLLabelElement;
          if (!emailRegex.test(value)) {
            setIsAble(false);
            next.classList.remove("hidden");
          }
          if (emailRegex.test(value)) {
            setEmlId(e.currentTarget.value);
            setIsAble(true);
            next.classList.add("hidden");
          }
        }}
      />
      <label
        htmlFor="emlId"
        className={
          "block  w-full pt-1 text-red-200 text-left text-xs hidden absolute"
        }
      >
        {t("alr_reg_mail")}
      </label>
      <div className="center mt-8 -mb-4">
        <Button
          text={t("btn_vrf_cmm")}
          styels="w-[100px]"
          disabled={!(!!emlId && isAble)}
          onClick={handleCheckPwd}
        />
      </div>
    </div>
  );
}
